export const TeamZeromatchingDashboards = {
  TeamZeromatchingDashboards: 
  {
    permissionsId:'0ca13d6a-ca6a-440f-7954-08dcaf947ea8',
    permissionsName:'Team Zeromatching' , 
    componentsId:null,
    components:null
  }
} ;
